// extracted by mini-css-extract-plugin
module.exports = {"header":"header-vcMKg","body":"body-18BMv"};